<template>
    <div class="upload-experience">
        <div class="upload-experience__content">
            <div class="upload-experience__content__text">请输入文章链接，目前支持微信公众号导入</div>
            <el-form ref="form" :model="form">
                <el-form-item :rules="rules" prop="url">
                    <el-input v-model="form.url" />
                </el-form-item>
            </el-form>
            
            <el-button round @click="handleImport" :loading="isImporting">导入</el-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { importArticle } from '@/api/experience';

export default {
    name: 'UploadExperience',
    data: () => ({
        isImporting: false,
        form: {
            url: '',
        },
        rules: [
            { validator: (rule, value, callback) => {
                value = value.trim();
                if (value === '') {
                    callback(new Error('请输入文章链接'));
                } else {
                    if (!value.toLowerCase().startsWith("http://") && !value.toLowerCase().startsWith("https://")) {
                        callback(new Error('文章链接格式不正确'));
                    }
                    callback();
                }
            }, trigger: 'blur' }
        ]
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    beforeRouteLeave(to, from, next) {
        if (this.isImporting) {
            this.$confirm('正在导入文章，是否确认离开此页面？')
                .then(() => {
                    next(true);
                })
                .catch(() => {
                    next(false);
                });
        } else {
            next();
        }
    },
    mounted() {
    },
    methods: {
        // 点击导入
        handleImport() {
            this.$refs.form.validate().then(() => {
                this.importArticle();
            });
        },
        // 导入文章
        importArticle() {
            this.isImporting = true;
            importArticle({
                url: this.form.url.trim()
            }).then(({ data }) => {
                this.$alert('文章导入成功', '', {
                    confirmButtonText: '确定',
                    callback: action => {
                        if (action === 'confirm') {
                            this.$router.push({ 
                                name: 'UploadExperience', 
                                params: {
                                    ...data
                                }
                            });
                        }
                    }
                });
            }).finally(() => {
                this.isImporting = false;
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.upload-experience {
    padding-top: 20px;
    
    &__content {
        margin: 0 auto;
        width: 40%;
        text-align: center;

        &__text {
            margin: 30px 0 20px 0;
            font-size: 14px;
            color: rgba(153, 153, 153, 1);
        }
        & /deep/ .el-button {
            margin-top: 5%;
            padding: 10px 30px;
        }
    }
}
</style>
